module.exports = {
        srcSet: __webpack_public_path__ + "static/media/image@2x-736.d821eecd.webp"+" 736w",
        images: [{path: __webpack_public_path__ + "static/media/image@2x-736.d821eecd.webp",width: 736,height: 1042}],
        src: __webpack_public_path__ + "static/media/image@2x-736.d821eecd.webp",
        toString: function(){return __webpack_public_path__ + "static/media/image@2x-736.d821eecd.webp"},
        
        width: 736,
        height: 1042
      }